import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';
import SDXModalDialog from 'lib/generic/SDXModalDialog';
import * as doT from 'dot';


const TAG_IMG = 'img';
const DIALOG_CLASS = 'enlarge-image-dialog';
const DIALOG_PADDING = 32;

/**
 * Big image view implemntation.
 *
 * @author Nikola Tica
 * @class Button
 * @extends Tc.Module
 */
export default class EnlargeImageView extends Module {
	private title! : string;
	private description! : string;
	private dialogWidth! : number;
	private dialogHeight! : number;
	private template! : doT.RenderFunction;
	private $modalContent! : JQuery;
	private imgSrc! : string;
	private imgWidth! : number;

	/**
	 * Hook function to do all of your module stuff.
	 *
	 * @method on
	 * @param  {Hook} callback Callback function
	 * @return void
	 */
	public on(callback : Hook) {
		const mod = this;
		this.title = this.$ctx.data('lightbox-title');
		this.description = this.$ctx.data('lightbox-description');
		this.dialogWidth = this.$ctx.data('lightbox-width');
		this.dialogHeight = this.$ctx.data('lightbox-height');
		this.template = doT.compile(this.$ctx.find('script.tmpl-big-image-preview').html());
		this.imgWidth = this.$ctx.data('img-width');

		const $img = this.$ctx.find(TAG_IMG);
		this.imgSrc = $img.data('lazy-src') || $img.attr('src') || '';

		const data = {
			description : this.description,
			src: this.imgSrc,
		};
		this.$modalContent = $(this.template(data));

		this.$ctx.find('.preview-link').on('click', function() {
			SDXModalDialog.show({
				class: DIALOG_CLASS,
				height: mod.dialogHeight,
				html: mod.$modalContent,
				title: mod.title,
				width: mod.dialogWidth || (mod.imgWidth + (DIALOG_PADDING * 2)),
			});
		});

		callback();
	}
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/img/Tc.Module.EnlargeImageView.ts